import React from 'react';
import { commonStyles } from 'utils/designSystem';

const SearchCard = ({ children }) => {
  return (
    <div style={commonStyles.card}>
      {children}
    </div>
  );
};

export default SearchCard;